import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminPage = () => {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for SSO callback with session_id in URL hash
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes('session_id=')) {
      handleSSOCallback();
      return;
    }

    // Check for existing token
    const savedToken = localStorage.getItem('admin_token');
    if (savedToken) {
      validateToken(savedToken);
    } else {
      setLoading(false);
    }
  }, []);

  const handleSSOCallback = async () => {
    try {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      
      if (!sessionId) {
        console.error('No session_id found in URL');
        setLoading(false);
        return;
      }

      // Exchange session_id for admin session via backend
      const res = await fetch(`${API}/api/admin/auth/sso`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId })
      });

      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('admin_token', data.token);
        setToken(data.token);
        setAdmin(data.admin);
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
      } else {
        const error = await res.json();
        console.error('SSO auth failed:', error.detail);
        // Clear the hash and show login
        window.history.replaceState(null, '', window.location.pathname);
      }
    } catch (err) {
      console.error('SSO callback error:', err);
      window.history.replaceState(null, '', window.location.pathname);
    } finally {
      setLoading(false);
    }
  };

  const validateToken = async (savedToken) => {
    try {
      const res = await fetch(`${API}/api/admin/auth/me`, {
        headers: { Authorization: `Bearer ${savedToken}` }
      });
      if (res.ok) {
        const data = await res.json();
        setToken(savedToken);
        setAdmin(data);
      } else {
        localStorage.removeItem('admin_token');
      }
    } catch (err) {
      localStorage.removeItem('admin_token');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (newToken, adminData) => {
    setToken(newToken);
    setAdmin(adminData);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
    setAdmin(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-emerald-500/30 border-t-emerald-500 rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-400">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!token) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminDashboard token={token} admin={admin} onLogout={handleLogout} />;
};

export default AdminPage;
